import React, { useEffect, useRef } from "react";
import { Link, NavLink } from "react-router-dom";
import "./Sidebar.css";
import logoBranca from "../../img/logos/logo-btk-white.svg";
import {
  IconFechar,
  IconFrete,
  IconHome,
  IconLista,
  IconProposta,
  IconRecolher,
  IconSair,
} from "../Icons/Icons";
import prenderFoco from "../Foco/prenderFoco";

export const ITENS_MENU = [
  { to: "/", label: "Início", Icone: IconHome, end: true },
  { to: "/Propostas", label: "Propostas", Icone: IconLista },
  { to: "/Proposta-Comercial", label: "Nova proposta", Icone: IconProposta },
  { to: "/Cotação-Frete", label: "Cotação de frete", Icone: IconFrete },
];

export default function Sidebar({
  id,
  recolhida,
  onAlternarRecolhida,
  aberta,
  onFechar,
  usuario,
  onSair,
  saindo = false,
}) {
  const sidebarRef = useRef(null);
  const fecharRef = useRef(null);

  useEffect(() => {
    if (aberta) fecharRef.current?.focus();
  }, [aberta]);

  const handleKeyDown = (event) => {
    if (aberta) prenderFoco(event, sidebarRef.current);
  };

  const classes = [
    "sidebar",
    recolhida && "sidebar--recolhida",
    aberta && "sidebar--aberta",
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <aside
      id={id}
      ref={sidebarRef}
      className={classes}
      aria-label="Menu lateral"
      onKeyDown={handleKeyDown}
    >
      <div className="sidebar-header">
        <Link to="/" className="sidebar-brand" title="BTK Solutions ERP">
          <span className="sidebar-logo">
            <img src={logoBranca} alt="BTK Solutions" />
          </span>
          <span className="sidebar-product">ERP</span>
        </Link>
        <button
          ref={fecharRef}
          type="button"
          className="sidebar-icon-button sidebar-close"
          aria-label="Fechar menu"
          onClick={onFechar}
        >
          <IconFechar />
        </button>
      </div>

      <nav className="sidebar-nav" aria-label="Principal">
        <p className="sidebar-section">Comercial</p>
        <ul className="sidebar-list">
          {ITENS_MENU.map(({ to, label, Icone, end }) => (
            <li key={to}>
              <NavLink
                to={to}
                end={end}
                title={recolhida ? label : undefined}
                className={({ isActive }) =>
                  `sidebar-link${isActive ? " sidebar-link--ativo" : ""}`
                }
              >
                <Icone className="sidebar-link-icon" />
                <span className="sidebar-link-label">{label}</span>
              </NavLink>
            </li>
          ))}
        </ul>
      </nav>

      <div className="sidebar-footer">
        {usuario && (
          <p className="sidebar-usuario" title={usuario.login}>
            <span className="sidebar-usuario-rotulo">Conectado como</span>
            <span className="sidebar-usuario-login">{usuario.login}</span>
          </p>
        )}
        <button
          type="button"
          className="sidebar-toggle"
          title={recolhida ? "Sair" : undefined}
          disabled={saindo}
          aria-busy={saindo}
          onClick={onSair}
        >
          <IconSair className="sidebar-link-icon" />
          <span className="sidebar-toggle-label">{saindo ? "Saindo…" : "Sair"}</span>
        </button>
        <button
          type="button"
          className="sidebar-toggle sidebar-recolher"
          aria-expanded={!recolhida}
          aria-controls={id}
          title={recolhida ? "Expandir menu" : undefined}
          onClick={onAlternarRecolhida}
        >
          <IconRecolher className="sidebar-toggle-icon" />
          <span className="sidebar-toggle-label">
            {recolhida ? "Expandir menu" : "Recolher menu"}
          </span>
        </button>
      </div>
    </aside>
  );
}
